<script setup>defineProps({id:String,blockId:String,minWidth:Number});const settings=useState('settings');</script>
<template><aside v-if="!settings?.disableAdvertising" class="plantcard-ad-slot" aria-label="Реклама"><AdContainer :id="id" :block-id="blockId" :min-width="minWidth" /></aside></template>
